<template>
  <div class="container page setbank-page">
    <van-nav-bar :title="$t('绑卡.钱包地址信息')" class="nav-bar">
      <template #left>
        <img src="/img/common/icon-back.png" @click="back()" style="width: 20px;height: 15px;"/>
      </template>
    </van-nav-bar>
    <div class="wrapper">
      <div class="add-card" @click="toBindCard()" v-if="!is_bind">
        <van-icon name="plus" />
        <span>{{ $t('绑卡.添加钱包地址') }}</span>
      </div>
      <div class="bank" v-else>
        <div class="bank-label">{{ $t('绑卡.加密货币类型') }}</div>
        <div class="row-content chain">{{ bankInfo.chain }}</div>
        <div class="bank-label">{{ $t('绑卡.钱包地址') }}</div>
        <div class="row-content address">{{ bankInfo.address }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      is_bind: false,
      bankInfo: {},
      userInfo: {},
    };
  },
  methods: {
    back() {
      return window.history.back();
    },
    getUserBankInfo() {
      this.$http({
        method: 'get',
        url: 'user_get_bank',
      }).then((res) => {
        if (res.code === 200) {
          if (res.data.is_bank) {
            this.is_bind = true;
            this.bankInfo = res.data.info;
          } else {
            this.is_bind = false;
          }
        } else {
          this.$toast(res.msg);
        }
      });
    },
    getUserInfo() {
      this.$http({
        method: 'get',
        url: 'user_info',
      }).then((res) => {
        if (res.code === 200) {
          this.userInfo = res.data;
        } else {
          this.$toast(res.msg);
        }
      });
    },
    toBindCard() {
      if (this.is_bind) {
        this.$toast(this.$t('绑卡.已绑定不可修改'));
        return;
      }
      if (!this.userInfo.name) {
        this.$toast(this.$t('绑卡.请先设置姓名'));
        this.$router.push({ path: '/Setname' });
        return;
      }
      this.$router.push({ path: '/BindCard' });
    },
  },
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push({ path: '/Login' });
    } else {
      this.getUserInfo();
      this.getUserBankInfo();
    }
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/base.css";

.setbank-page {
  background: #1f1c1f;
  min-height: 100vh;
}

.wrapper {
  padding: 30px;
  box-sizing: border-box;
}

.add-card {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 250px;
  color: #f3c7a2;
  background: linear-gradient(120deg, #212121, #313131);
  border: 1px solid #766350;
  border-radius: 16px;
  cursor: pointer;

  span {
    margin-left: 12px;
    font-size: 30px;
  }
}

.bank {
  padding: 36px 30px;
  background: linear-gradient(120deg, #212121, #313131);
  border: 1px solid #766350;
  border-radius: 16px;
}

.bank-label {
  font-size: 24px;
  color: #999;
  margin-bottom: 12px;
}

.row-content {
  font-size: 30px;
  color: #f3c7a2;
  word-break: break-all;
  margin-bottom: 28px;
  line-height: 1.4;

  &:last-child {
    margin-bottom: 0;
  }
}

.row-content.chain {
  font-weight: 700;
  font-size: 34px;
}
</style>
